<router-outlet></router-outlet>
@if (toastService.shouldShow) {
  <shared-toast></shared-toast>
}
@if (alertService.shouldShow) {
  <blu-alert></blu-alert>
}
